import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SmtpSettingsComponent } from './smtp-settings/smtp-settings.component';

const routes: Routes = [
    {
        path: '', component: SmtpSettingsComponent
    }
];

@NgModule({
    declarations: [
        SmtpSettingsComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatDialogModule,
        MatIconModule,
        MatSlideToggleModule,
        MatTooltipModule,
        RouterModule.forChild(routes),
    ]
})
export class SmtpSettingsModule { }
